









import { Vue, Component, Prop, Watch } from "vue-property-decorator"

@Component({})
export default class Modal extends Vue {
  @Prop() data: any

  closeModal() {
    this.$emit("close-modal")
  }
}
